import { Component } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import 'rxjs/add/operator/pairwise';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { ServiciosGenerales } from '../app/main/content/Servicios/ServiciosGenerales.service';
import { AuthService } from '../app/main/content/Seguridad/auth.service';



@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(private fuseSplashScreen: FuseSplashScreenService, private router: Router,private _serviciosGenerales: ServiciosGenerales,private _authService:AuthService) {

        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.router.routerState.root)
            .subscribe((event) => {
            });
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (sessionStorage.getItem('idsesion') != null){
                    this._serviciosGenerales.post("usuario/login/validar/idsesion/"+sessionStorage.getItem('idsesion'),{ usuario: JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().usuario).usuario , empresa : JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().empresa).empresa }).subscribe(res => {
                        if (res.error == true) {
                            _authService.clearSession(this._serviciosGenerales);
                            this.router.navigate(['/login']);
                        }
                    }, error => {
                    })
                }
            }
            if (event instanceof NavigationEnd) {
            }

        });

    }
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/app.component.ts